<template>
  <v-row no-gutters>
    <v-col cols="12" md="5" lg="7">
      <theHeading />
    </v-col>
    <v-col cols="12" md="7" lg="5" class="d-flex flex-row">
      <v-text-field
        dense
        v-model="quickSearch"
        @input="$emit('onQuickSearchChanged', quickSearch)"
        label="Cerca..."
        prepend-inner-icon="search"
        hide-details
      />
      <div style="width: 60px" class="mx-4">
        <v-select
          :items="tableRowsOptions"
          v-model="tableRows"
          dense
          hide-details
        />
      </div>

      <v-menu bottom left offset-y :close-on-content-click="false">
        <template v-slot:activator="{ on }">
          <v-btn tile icon v-on="on">
            <img
              height="15"
              width="15"
              src="../../../assets/icons/columns.svg"
            />
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-for="(column, index) in editableCols" :key="index">
            <v-checkbox
              v-model="colsChecksVisibilityComputed"
              @change="$emit('toggleColumn', column)"
              :label="column.headerName"
              :value="column.field"
              dense
              class="my-0"
            />
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu bottom left offset-y :close-on-content-click="false">
        <template v-slot:activator="{ on }">
          <v-btn tile icon v-on="on">
            <img
              height="15"
              width="15"
              src="../../../assets/icons/download.svg"
            />
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click.stop="$emit('getCsv')">
            CSV (separador ";")
          </v-list-item>
        </v-list>
      </v-menu>

      <create-item
        v-if="settings.create"
        :service="service"
        @createTableItem="createTableItem"
        :createTitle="createTitle"
        :dialogLargeSize="dialogLargeSize"
        :modelKeyTitle="modelKeyTitle"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  components: {
    theHeading: () => import("@/layouts/intranet/components/viewHeading.vue"),
    createItem: () => import("@/components/crud_ag/actions/Create.vue"),
  },
  props: {
    settings: {
      type: Object,
      required: true,
    },
    editableCols: {
      type: Array,
      required: true,
    },
    colsChecksVisibility: {
      type: Array,
      required: true,
    },
    service: {
      type: Object,
      required: true,
    },
    dialogLargeSize: {
      type: Boolean,
      required: true,
    },
    createTitle: {
      type: String,
      required: true,
    },
    modelKeyTitle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      quickSearch: null,
      tableRowsOptions: ["25", "50", "100", "250", "500"],
    }
  },
  methods: {
    createTableItem(id) {
      this.$emit("createTableItem", id)
    },
  },
  computed: {
    tableRows: {
      get() {
        return this.settings.tableRows.toString()
      },
      set(value) {
        this.$emit("onTableRowsChange", value)
      },
    },
    colsChecksVisibilityComputed: {
      get() {
        return this.colsChecksVisibility
      },
      set(value) {
        this.$emit("updateColsChecksVisibility", value)
      },
    },
  },
}
</script>

<style lang="scss" scoped></style>
